exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Terms {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  align-content: center;\n  overflow: hidden; }\n  @media screen and (max-width: 600px) {\n    .Terms {\n      flex-direction: column; } }\n  .Terms img {\n    width: 100%; }\n    @media screen and (max-width: 600px) {\n      .Terms img {\n        width: 100%; } }\n", ""]);

// exports
